import { useState } from "react";
import { Container } from "react-bootstrap";

import Button from "../Button";
import AddEditClientModal from "../CaseManagement/AddEditClientModal";
import PageHeader from "../PageHeader";
import SearchInput from "../SearchInput";
import ClientsTable from "./ClientsTable";

export default function Clients() {
  const [search, setSearch] = useState("");
  const [showAddClient, setShowAddClient] = useState(false);

  return (
    <Container className="page-container-multi">
      <AddEditClientModal
        title="Add Client"
        submitButtonText="Add"
        isShow={showAddClient}
        onClose={() => setShowAddClient(false)}
        onClientSaved={() => {}}
        users={[]}
      />
      <PageHeader
        testId="clients-header"
        title="Clients"
        cta={
          <Button variant="default" onClick={() => setShowAddClient(true)}>
            Add New Client
          </Button>
        }
      />

      <div className="search-input-wrapper">
        <SearchInput
          value={search}
          onChange={(value) => setSearch(value)}
          placeholder="Search clients"
        />
      </div>
      <div className="pt-2">
        <h2 style={{ marginTop: "0px" }}>Recent Clients</h2>
        <ClientsTable search={search} recent />
      </div>
      <div className="pt-4">
        <h2 style={{ marginTop: "0px" }}>All Clients</h2>
        <ClientsTable search={search} />
      </div>
    </Container>
  );
}
